import React, { useEffect, useState } from "react";
import { Formik, FieldArray, Field, useFormikContext } from "formik";
import { PlusIcon as PlusIcon } from "@heroicons/react/24/solid";
import {
  TrashIcon as TrashIconMini,
  PlusCircleIcon,
} from "@heroicons/react/20/solid";
import { useQuery, gql, useMutation } from "@apollo/client";
// import { ToastContainer, toast } from "react-toastify";
import _ from "lodash";
import DiagnosisSearchNSelect from "./request/DiagnosisSearchNSelect";
import supportingInfoElements from "./request/SupportingInfoElement";
import {
  items as sites,
  dentalItems as oralItems,
  investigationResult,
} from "../components/request/BodySites";
import ItemCodesSearchNSelect from "./request/ItemCodesSearchNSelect";
import { MdAttachFile, MdDownload } from "react-icons/md";
import DentalTeethSelectModal from "./DentalTeethSelectModal";
import { Button, Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import { string } from "yup";
import MorphologySearch from "./request/MorphologySearch";
import { useTranslation } from "react-i18next";
import CustomFilterInput from "../../../shared/CustomFilterInput";
import AppTable from "../../../shared/AppTable";

const menuItems = [
  { text: "Inbox", icon: <InboxIcon /> },
  { text: "Starred", icon: <MailIcon /> },
  { text: "Send email", icon: <InboxIcon /> },
  { text: "Drafts", icon: <MailIcon /> },
  { text: "All mail", icon: <InboxIcon /> },
  { text: "Trash", icon: <MailIcon /> },
  { text: "Spam", icon: <InboxIcon /> },
];

function SupportingInfoForm({ onChange, refId }) {
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    setFieldValue,
  } = useFormikContext();
  const { t, i18n } = useTranslation();
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const DrawerList = (push) => (
    <Box className="w-full" role="presentation">
      <List className="w-full flex items-center flex-wrap gap-1.5">
        {supportingInfoElements(t).map((item, index) => (
          <ListItem
            key={item.id}
            disablePadding
            className="!p-0 !min-w-[70px] max-w-fit !px-2 !flex !items-center !justify-center border !border-gray-600 rounded"
          >
            <ListItemButton
              onClick={() => {
                push(item.object);
                setSupportingInfo(index);
              }}
              className="!p-0 !text-gray-600"
            >
              <ListItemText
                primary={item?.name}
                primaryTypographyProps={{
                  className: "!text-[12px] !text-gray-600",
                }}
              />
              <ListItemIcon className="!ml-2 !min-w-fit !text-gray-600">
                {item?.icon}
              </ListItemIcon>
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  const [showTeethSelectModal, setShowTeethSelectModal] = useState(false);
  const [supportingInfo, setSupportingInfo] = useState("");

  const addData = (values) => {
    let data = _.cloneDeep(values);
    // createInsurancePlan({ variables: { input: data } });
  };

  //method to transform category value to kebab-case
  const transformedData = () => {
    let data = [];

    supportingInfoElements(t).map((obj) => {
      // iterate over each object and transform its category property
      data.push({
        ...obj, // spread operator to copy all other properties
        object: {
          ...obj.object, // copy all other properties of nested object
          category: obj.object.category.toLowerCase().replace(/\s+/g, "-"),
        },
      });
    });

    return data;
  };

  function downloadBase64File(base64Data, fileName, fileType) {
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: fileType });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    URL.revokeObjectURL(url);
  }

  const tableHeaders = [
    {
      name: t("No."),
    },
    {
      name: t("Category"),
    },
    {
      name: t("Code"),
    },
    {
      name: t("Timing"),
    },
    {
      name: t("Value"),
    },
    {
      name: t("Attachment"),
    },
    {
      name: t("Reason"),
    },
    {
      name: "",
    },
  ];
  const columns = [
    {
      header: t("No."),
      render: (row, index) => (
        <span className="text-[12px] font-bold text-gray-700">{index + 1}</span>
      ),
    },
    {
      header: t("Category"),
      render: (row) => (
        <span className="text-[12px] font-bold text-gray-700 lowercase">
          {row.category}
        </span>
      ),
    },
    {
      header: t("Code"),
      render: (row, index) => (
        <div className="min-w-[200px]">
          {/* Code Text Logic */}
          {row.code && (
            <Tooltip title={`${row.code_text} - ${row.code}`}>
              <div className="text-[11px] font-bold text-blue-600 mb-1">
                {row.code} ({row.code_text?.slice(0, 20)}...)
              </div>
            </Tooltip>
          )}

          {/* Conditional Search Components */}
          {row.category !== "missingtooth" &&
          row.category !== "investigation-result" ? (
            row.category === "lab-test" ? (
              <ItemCodesSearchNSelect
                typeName="loinc"
                setFieldValue={(val) => {
                  setFieldValue(`supportingInfos.${index}.code`, val.code);
                  setFieldValue(
                    `supportingInfos.${index}.codeText`,
                    val.description,
                  );
                }}
              />
            ) : row.category === "morphology" ? (
              <MorphologySearch
                values={row}
                setFieldValue={(val) => {
                  setFieldValue(`supportingInfos.${index}.code`, val.Code);
                  setFieldValue(
                    `supportingInfos.${index}.codeText`,
                    val.Display,
                  );
                }}
              />
            ) : (
              <DiagnosisSearchNSelect
                category={row.category}
                values={row}
                setFieldValue={(val) => {
                  setFieldValue(`supportingInfos.${index}.code`, val.CodeId);
                  setFieldValue(
                    `supportingInfos.${index}.codeText`,
                    val.AsciiDescription,
                  );
                }}
              />
            )
          ) : (
            // Simple Select for Investigation or Oral
            <CustomFilterInput
              isSelect
              placeholder={t("Please Select")}
              options={
                row.category === "investigation-result"
                  ? investigationResult
                  : oralItems
              }
              value={row.code}
              onChange={(e) => {
                const val = e.target.value;
                const list =
                  row.category === "investigation-result"
                    ? investigationResult
                    : oralItems;
                const found = _.find(list, { id: val });
                setFieldValue(`supportingInfos.${index}.code`, val);
                setFieldValue(`supportingInfos.${index}.codeText`, found?.name);
              }}
            />
          )}
        </div>
      ),
    },
    {
      header: t("Timing"),
      render: (row, index) => (
        <div className="flex gap-1 min-w-[180px]">
          {"startDate" in row && (
            <CustomFilterInput
              type="date"
              label={t("Start")}
              name={`supportingInfos.${index}.startDate`}
              value={row.startDate}
              onChange={handleChange}
            />
          )}
          {"endDate" in row && (
            <CustomFilterInput
              type="date"
              label={t("End")}
              name={`supportingInfos.${index}.endDate`}
              value={row.endDate}
              onChange={handleChange}
            />
          )}
        </div>
      ),
    },
    {
      header: t("Value"),
      render: (row, index) => (
        <div className="min-w-[180px]">
          {"value" in row && (
            <CustomFilterInput
              type={
                [
                  "chief-complaint",
                  "history-of-present-illness",
                  "patient-history",
                  "physical-examination",
                  "treatment-plan",
                  "info",
                ].includes(row.category)
                  ? "textarea"
                  : "text"
              }
              placeholder={t("Value")}
              name={`supportingInfos.${index}.value`}
              value={row.value}
              onChange={handleChange}
              // Value unit suffix inside input if needed
            />
          )}
        </div>
      ),
    },
    {
      header: t("Attachment"),
      render: (row, index) => (
        <div className="min-w-[150px]">
          {"attachment" in row &&
            (!row?.fileName ? (
              <input
                type="file"
                className="text-[12px]"
                onChange={(e) => handleImageChange(e, setFieldValue, index)}
              />
            ) : (
              <div className="flex items-center gap-1 text-blue-600 cursor-pointer">
                <MdAttachFile />
                <span className="text-[11px] truncate w-20">
                  {row?.fileName}
                </span>
                <MdDownload
                  onClick={() => {
                    if (row?.imageUrl && row?.imageUrl !== "") {
                      const a = document.createElement("a");
                      a.href = row?.imageUrl;
                      a.download = row?.fileName || "download";
                      a.target = "_blank";
                      document.body.appendChild(a);
                      a.click();
                      document.body.removeChild(a);
                    } else if (row?.attachment) {
                      downloadBase64File(
                        row?.attachment,
                        row?.fileName,
                        row?.fileType,
                      );
                    }
                  }}
                />
              </div>
            ))}
        </div>
      ),
    },
    {
      header: t("Reason"),
      render: (row, index) => (
        <div className="min-w-[130px]">
          {"reason" in row && (
            <CustomFilterInput
              isSelect
              placeholder={t("Reason")}
              options={
                row.category === "missingtooth"
                  ? missingToothReasons
                  : vitalSignReasonLOVs[row.category] || []
              }
              value={row.reason}
              onChange={handleChange}
              name={`supportingInfos.${index}.reason`}
            />
          )}
        </div>
      ),
    },
  ];
  const handleImageChange = (e, setFieldValue, index) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      setFieldValue(`supportingInfos.${index}.fileName`, file.name);
      setFieldValue(`supportingInfos.${index}.fileType`, file.type);

      // Use the extracted base64Data for further processing or upload
      const base64Data = reader.result.split(",")[1]; // Remove data type prefix

      setFieldValue(`supportingInfos.${index}.attachment`, base64Data);
      // Clear minio path so backend knows this is a new upload
      setFieldValue(`supportingInfos.${index}.imageMinioPath`, null);
      setFieldValue(`supportingInfos.${index}.imageUrl`, null);
    };
  };

  const missingToothReasons = [
    { id: "extraction", name: "Extraction" },
    { id: "congenital", name: "Congenital" },
    { id: "unknown", name: "Unknown" },
    { id: "other", name: "Other" },
  ];

  const getRequiredItemName = (desiredId) => {
    const result = _.find(oralItems, { id: desiredId });
    return result.name;
  };

  const getRequiredInvertigationName = (desiredId) => {
    const result = _.find(investigationResult, { id: desiredId });
    return result.name;
  };

  const vitalSignReasonLOVs = {
    "vital-sign-height": [{ id: "999.9", name: "Not Measured" }],
    "vital-sign-weight": [{ id: "999.9", name: "Not Collected" }],
    "vital-sign-systolic": [
      { id: "888", name: "Not measurable" },
      { id: "999", name: "Unknown" },
    ],
    "vital-sign-diastolic": [
      { id: "888", name: "Not measurable" },
      { id: "999", name: "Unknown" },
    ],
    temperature: [
      { id: "88", name: "Not Obtained" },
      { id: "99", name: "Unknown" },
    ],
    pulse: [
      { id: "997", name: "Cardiac Arrest" },
      { id: "998", name: "Not Recorded" },
      { id: "999", name: "Not Stated" },
    ],
    "respiratory-rate": [
      { id: "00", name: "Artificial Ventilation" },
      { id: "88", name: "Not Obtained" },
      { id: "99", name: "Unknown" },
    ],
    "oxygen-saturation": [
      { id: "888", name: "Not Obtained" },
      { id: "999", name: "Unknown" },
    ],
  };

  useEffect(() => {
    const categoriesToMonitor = [
      "vital-sign-weight",
      "vital-sign-diastolic",
      "vital-sign-height",
      "vital-sign-systolic",
      "pulse",
      "oxygen-saturation",
      "temperature",
      "respiratory-rate",
    ];

    values.supportingInfos.forEach((info, index) => {
      if (categoriesToMonitor.includes(info.category) && info.value) {
        setFieldValue(`supportingInfos.${index}.reason`, null);
      }
    });
  }, [values.supportingInfos, setFieldValue]);

  useEffect(() => {
    const { claimType, isNewBorn, supportingInfos } = values;

    // Initialize an array to hold new items to push
    let newItemsToPush = [];

    // Define categories for each claim type
    const requiredCategoriesByType = {
      professional: [
        "chief-complaint",
        "vital-sign-weight",
        "vital-sign-diastolic",
        "vital-sign-height",
        "vital-sign-systolic",
        "treatment-plan",
        "history-of-present-illness",
        "patient-history",
        "physical-examination",
        "pulse",
        "oxygen-saturation",
        "temperature",
        "respiratory-rate",
        "investigation-result",
      ],
      institutional: [
        "chief-complaint",
        "vital-sign-weight",
        "vital-sign-diastolic",
        "vital-sign-height",
        "vital-sign-systolic",
        "treatment-plan",
        "history-of-present-illness",
        "patient-history",
        "physical-examination",
        "estimated-Length-of-Stay",
        "pulse",
        "oxygen-saturation",
        "temperature",
        "respiratory-rate",
        "investigation-result",
      ],
      oral: [
        "chief-complaint",
        "treatment-plan",
        "history-of-present-illness",
        "patient-history",
        "physical-examination",
        "investigation-result",
      ],
      vision: [
        "treatment-plan",
        "history-of-present-illness",
        "patient-history",
        "physical-examination",
        "investigation-result",
      ],
      pharmacy: [
        "treatment-plan",
        "history-of-present-illness",
        "patient-history",
        "physical-examination",
        "investigation-result",
      ],
    };

    const categoriesToPush = requiredCategoriesByType[claimType] || [];

    // Collect all items that need to be pushed
    categoriesToPush.forEach((category) => {
      const itemToPush = supportingInfoElements(t).find(
        (item) => item.object.category === category,
      );

      if (
        itemToPush &&
        !supportingInfos.some((info) => info.category === category)
      ) {
        // If the category doesn't already exist, add the full object to newItemsToPush
        newItemsToPush.push(itemToPush.object);
      }
    });

    // If claimType is institutional and isNewBorn is true, push birth-weight and admission-weight
    if (claimType === "institutional" && isNewBorn) {
      const birthWeightItem = supportingInfoElements(t).find(
        (item) => item.object.category === "birth-weight",
      );

      const admissionWeightItem = supportingInfoElements(t).find(
        (item) => item.object.category === "admission-weight",
      );

      // Push birth-weight if it doesn't already exist
      if (
        birthWeightItem &&
        !supportingInfos.some((info) => info.category === "birth-weight")
      ) {
        newItemsToPush.push(birthWeightItem.object);
      }

      // Push admission-weight if it doesn't already exist
      if (
        admissionWeightItem &&
        !supportingInfos.some((info) => info.category === "admission-weight")
      ) {
        newItemsToPush.push(admissionWeightItem.object);
      }
    }

    // Update supportingInfos only if there are new items to push
    if (newItemsToPush.length > 0) {
      setFieldValue("supportingInfos", [...supportingInfos, ...newItemsToPush]);
    }
  }, [values.claimType, values.isNewBorn]);

  return (
    <div className="personal-data !p-2 !mb-2">
      {/* 1. Header Section */}
      <div className="personal-title !mb-2 flex items-center gap-2">
        <div className="inventory-svg">
          <svg width="26" height="26" viewBox="0 0 34 34" fill="none">
            <rect width="34" height="34" rx="8" fill="#F4F6F8"></rect>
            <path
              d="M9.25 11H11.25V14H21.25V11H23.25V16H25.25V11C25.25 9.9 24.35 9 23.25 9H19.07C18.65 7.84 17.55 7 16.25 7C14.95 7 13.85 7.84 13.43 9H9.25C8.15 9 7.25 9.9 7.25 11V25C7.25 26.1 8.15 27 9.25 27H15.25V25H9.25V11ZM16.25 9C16.8 9 17.25 9.45 17.25 10C17.25 10.55 16.8 11 16.25 11C15.7 11 15.25 10.55 15.25 10C15.25 9.45 15.7 9 16.25 9Z"
              fill="#0070c2"
            ></path>
            <path
              d="M25.25 17.5L19.76 23L16.75 20L15.25 21.5L19.76 26L26.75 19L25.25 17.5Z"
              fill="#0070c2"
            ></path>
          </svg>
        </div>
        <div className="personal-head">
          <span>{t("Supporting Info")}</span>
        </div>
      </div>

      {/* 2. FieldArray Section */}
      <FieldArray name="supportingInfos">
        {({ push, remove }) => (
          <>
            {/* Buttons List to Add Items */}
            <div className="mb-2">
              <Box className="w-full border border-gray-200 rounded-md p-2">
                <List className="flex flex-wrap gap-x-1.5 gap-y-1.5 !m-0 !p-0">
                  {supportingInfoElements(t).map((item) => (
                    <ListItem
                      key={item.id}
                      disablePadding
                      className="max-w-fit border border-gray-200 rounded-md bg-white hover:bg-gray-50 transition-colors"
                    >
                      <ListItemButton
                        onClick={() => push(item.object)}
                        className="!py-1 !px-3 rounded-md"
                      >
                        <ListItemText
                          primary={item.name}
                          primaryTypographyProps={{
                            className:
                              "!text-[11.5px] !font-bold text-gray-600",
                          }}
                          className="!m-0"
                        />
                        <ListItemIcon className="!min-w-fit ml-2.5 text-gray-500">
                          {React.cloneElement(item.icon, {
                            style: { fontSize: "13px" },
                          })}
                        </ListItemIcon>
                      </ListItemButton>
                    </ListItem>
                  ))}
                </List>
              </Box>
            </div>

            {/* 3. The New AppTable (Replacement for <table>) */}
            <div className="supporting-info-app-table">
              <style>{`
                .supporting-info-app-table table thead th {
                  font-size: 12px !important;
                  color: #1e293b !important;
                  text-transform: uppercase !important;
                  font-weight: 800 !important;
                  padding-top: 4px !important;
                  padding-bottom: 4px !important;
                }
                .supporting-info-app-table table tbody td {
                  font-size: 12px !important;
                  color: #334155 !important;
                }
                .supporting-info-app-table table tbody td .MuiSvgIcon-root {
                  font-size: 18px !important;
                }
              `}</style>
              <AppTable
                columns={columns} // Ye upar define kiya hua hona chahiye
                data={values.supportingInfos || []}
                onDelete={(row) => {
                  const idx = values.supportingInfos.indexOf(row);
                  remove(idx);
                }}
                actions={true}
              />
            </div>
          </>
        )}
      </FieldArray>

      {/* Error Messages Section */}
      {errors.supportingInfos && touched.supportingInfos && (
        <div className="mt-2 p-2 border border-red-200 bg-red-50 rounded text-[11px] text-red-600">
          {/* Error Mapping Logic as per your requirement */}
          {t("Please check all required supporting information fields")}
        </div>
      )}

      {/* Modals */}
      <DentalTeethSelectModal
        showTeethSelectModal={showTeethSelectModal}
        setShowTeethSelectModal={setShowTeethSelectModal}
        setFieldValue={setFieldValue}
      />
    </div>
  );
}

export default SupportingInfoForm;
